import React from 'react';

export default function SpringFlower() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="21"
			height="18"
			fill="none"
		>
			<path
				fill="#0F440F"
				d="M10.5 0a3.51 3.51 0 0 0-3.55 3.45c0 .46.08 1 .23 1.59a7.97 7.97 0 0 0-1.9-1.06A3.59 3.59 0 0 0 .72 6a3.43 3.43 0 0 0 2.1 4.43c.72.27 1.78.44 2.86.44a7.8 7.8 0 0 0-1.56 1.51 3.4 3.4 0 0 0 .83 4.81c1.6 1.1 3.82.74 4.96-.8.31-.44.62-1.03.87-1.7.27.74.6 1.39.94 1.85a3.62 3.62 0 0 0 4.95.81 3.4 3.4 0 0 0 .83-4.8 8.23 8.23 0 0 0-1.74-1.67c.92-.04 1.8-.2 2.43-.43a3.43 3.43 0 0 0 2.09-4.43 3.59 3.59 0 0 0-4.56-2.04c-.57.2-1.25.59-1.9 1.07.15-.59.23-1.15.23-1.6A3.5 3.5 0 0 0 10.5 0Zm-.06 1.15h.06a2.33 2.33 0 0 1 2.37 2.3c0 .61-.29 1.83-.74 2.87a3.24 3.24 0 0 0-3.26 0 8.67 8.67 0 0 1-.74-2.87 2.33 2.33 0 0 1 2.3-2.3ZM4.06 4.9c.27 0 .55.05.82.15a9.6 9.6 0 0 1 3 2.17 3.03 3.03 0 0 0-.53 2.33c-1.33.26-3.34.1-4.13-.18a2.28 2.28 0 0 1-1.4-2.96 2.36 2.36 0 0 1 2.24-1.5Zm12.88.02c.97 0 1.88.57 2.24 1.5a2.28 2.28 0 0 1-1.4 2.97c-.79.28-2.8.44-4.13.18a3.04 3.04 0 0 0-.51-2.33 9.61 9.61 0 0 1 2.99-2.17c.27-.1.54-.15.82-.15Zm-3.8 5.85a9.79 9.79 0 0 1 3.4 2.45 2.25 2.25 0 0 1-.55 3.21 2.4 2.4 0 0 1-3.31-.54c-.5-.68-1.2-2.6-1.26-3.9.7-.21 1.3-.65 1.71-1.22Zm-5.21.08a3.23 3.23 0 0 0 2.26 1.25c-.14 1.3-.78 3-1.25 3.63a2.4 2.4 0 0 1-3.3.54 2.25 2.25 0 0 1-.56-3.21 9.54 9.54 0 0 1 2.85-2.2Z"
			/>
		</svg>
	);
}
